import { Grid } from 'pcln-design-system';
import React, { memo, useCallback } from 'react';
import DatePicker from '../DatePicker';
import TimePicker from '../TimePicker';
/** @public */
function CarDatePicker({
  dropoffDate,
  dropoffDateErrorMessage,
  dropoffTime,
  dropoffTimeErrorMessage,
  hasShadowEffect,
  hideTooltip,
  pickupDate,
  pickupDateErrorMessage,
  pickupTime,
  pickupTimeErrorMessage,
  height = '48px',
  infoBannerContent,
  isMobile,
  isPersistentCalendar,
  maxDate,
  rightAlignDropoffCalendar,
  rightAlignPickupCalendar,
  zIndex = 3,
  onClose,
  onDropoffDateChange,
  onDropoffTimeChange,
  onOpen,
  onPickupDateChange,
  onPickupTimeChange,
  ...props
}) {
  const onPickupSelection = useCallback(dates => {
    if (isPersistentCalendar) {
      ;
      document.querySelector('button[name="dropoff-date"]').focus();
    }
    onPickupDateChange(dates);
  }, []);
  const onDropoffSelection = useCallback(dates => {
    if (isPersistentCalendar) {
      ;
      document.activeElement.blur();
    }
    onDropoffDateChange(dates);
  }, []);
  return React.createElement(Grid, {
    gap: 3,
    templateColumns: ['1fr 1fr', null, null, '1fr minmax(110px, 1fr) 1fr minmax(110px, 1fr)'],
    ...props
  }, React.createElement(DatePicker, {
    allowSameDay: true,
    endDate: dropoffDate,
    errorMessage: pickupDateErrorMessage,
    hasShadowEffect: hasShadowEffect,
    height: height,
    hideTooltip: hideTooltip,
    infoBannerContent: infoBannerContent,
    initialDates: {
      startDate: pickupDate
    },
    isMobile: isMobile,
    label: 'Pick-up',
    maxDate: maxDate,
    name: 'pickup-date',
    onChange: onPickupSelection,
    onClose: onClose,
    onOpen: onOpen,
    rightAlignCalendar: rightAlignPickupCalendar,
    selectTwoDates: false,
    showHoveredDates: !!dropoffDate,
    useDefaultFooter: true,
    zIndex: zIndex
  }), React.createElement(TimePicker, {
    errorMessage: pickupTimeErrorMessage,
    hasShadowEffect: hasShadowEffect,
    height: height,
    hideTooltip: hideTooltip,
    label: 'Pick-up time',
    value: pickupTime,
    zIndex: zIndex,
    onClose: onClose,
    onChange: onPickupTimeChange,
    onOpen: onOpen
  }), React.createElement(DatePicker, {
    allowSameDay: true,
    endDate: dropoffDate,
    errorMessage: dropoffDateErrorMessage,
    hasShadowEffect: hasShadowEffect,
    height: height,
    hideTooltip: hideTooltip,
    infoBannerContent: infoBannerContent,
    initialDates: {
      startDate: dropoffDate
    },
    isMobile: isMobile,
    label: 'Drop-off',
    maxDate: maxDate,
    minDate: pickupDate,
    name: 'dropoff-date',
    onChange: onDropoffSelection,
    onClose: onClose,
    onOpen: onOpen,
    rightAlignCalendar: rightAlignDropoffCalendar,
    selectTwoDates: false,
    showHoveredDates: true,
    startDate: pickupDate,
    useDefaultFooter: true,
    zIndex: zIndex
  }), React.createElement(TimePicker, {
    errorMessage: dropoffTimeErrorMessage,
    hasShadowEffect: hasShadowEffect,
    height: height,
    hideTooltip: hideTooltip,
    label: 'Drop-off time',
    value: dropoffTime,
    zIndex: zIndex,
    onClose: onClose,
    onChange: onDropoffTimeChange,
    onOpen: onOpen
  }));
}
export default memo(CarDatePicker);